import { ScrollInViewBehaviourType } from "../../enum/ScrollInViewTypes";

const useScrollToTop = (behavior?: ScrollBehavior | undefined) => {
  window.scrollTo({
    top: 0,
    behavior: behavior ? behavior : ScrollInViewBehaviourType.AUTO,
  });
};

export default useScrollToTop;
